import { useState, useCallback } from 'react';

export const useAsyncLoading = <T = void>() => {
  const [loading, setLoading] = useState(false);

  const execute = useCallback(async (asyncFn: () => Promise<T>) => {
    setLoading(true);
    try {
      const result = await asyncFn();
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, execute };
};
